export const convertIdentificationInfoToSelectOptions = (
  identificationInfo: any[]
) => {
  return identificationInfo?.map((item: any) => ({
    label: item.name,
    value: item.id,
  }))
}
